export default {
  title: 'Regiones de países',

  titles: {
    create: 'Crear región'
  },

  labels: {
    region: 'Región',
    country: 'País',
    regionCode: 'Código de región',
    regionName: 'Nombre de la región',
    countryCode: 'Código de país',
    countryName: 'Nombre del país',
    timeZone: 'Zona horaria'
  },

  rules: {
    length: {
      range: 'Longitud de {minLength} a {maxLength} caracteres',
      exact: 'Longitud {maxLength} caracteres'
    },

    pattern: {
      regionCode: 'Letras latinas y dígitos',
      regionName: 'Letras cirílicas y latinas, dígitos, espacio, apóstrofo y guion',
      countryCode: 'Letras latinas mayúsculas',
      countryName: 'Letras cirílicas y latinas, espacio, apóstrofo y guion',
      timeZone: 'Formato UTC+HH:MM o UTC-HH:MM'
    }
  },

  infos: {
    form: '<b>Código de región</b> - dentro del país, por ejemplo 77 o CA.<br><b>Nombre de la región</b> - por ejemplo Moscú.<br><b>Código de país</b> - código de dos letras, por ejemplo RU.<br><b>Nombre del país</b> - por ejemplo Rusia.<br><b>Zona horaria</b> - desplazamiento respecto a UTC, por ejemplo UTC+03:00.'
  },

  warnings: {
    form: 'El par <b>código de país</b> y <b>código de región</b> debe ser único.'
  },

  snackbars: {
    created: 'Región creada con éxito.',
    updated: 'Región actualizada con éxito.',
    removed: 'Región eliminada con éxito.'
  }
}
